import { inIframe } from './trail_helpers';

function modalSignup(ref, returnTo) {
  window.onbeforeunload = null; // remove prompts before leaving page

  const isMobile = typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  // If on mobile or in iframe always go to full page
  if ((isMobile || inIframe()) && window && window.top) {
    window.top.location = window.checkLinkAndAppendLanguage(`/signup?returnTo=${returnTo}&ref=${ref}`);
    return false;
  }
  if (window) {
    window.location = window.checkLinkAndAppendLanguage(`/signup?returnTo=${returnTo}&ref=${ref}`);
  }
  return false;
}

function modalPro(ref, returnTo) {
  window.onbeforeunload = null; // remove prompts before leaving page

  const isMobile = typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  // If on mobile or in iframe always go to full page
  if ((isMobile || inIframe()) && window && window.top) {
    window.top.location = window.checkLinkAndAppendLanguage(`/pro?returnTo=${returnTo}&ref=${ref}`);
    return false;
  }
  if (window) {
    window.location = window.checkLinkAndAppendLanguage(`/pro?returnTo=${returnTo}&ref=${ref}`);
  }
  return false;
}

export { modalSignup };
export { modalPro };
